import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"trigger__icon icon--left\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 2v4\"></path><path d=\"M16 2v4\"></path><rect width=\"18\" height=\"18\" x=\"3\" y=\"4\" rx=\"2\"></rect><path d=\"M3 10h18\"></path></svg></div>", 1)
const _hoisted_2 = { class: "trigger__main" }
const _hoisted_3 = {
  key: 0,
  class: "main__value"
}
const _hoisted_4 = {
  key: 1,
  class: "main__placeholder"
}
const _hoisted_5 = {
  key: 0,
  class: "bs-date-field__validation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_date_calendar = _resolveComponent("bs-date-calendar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bs-date-field bs-date-field--icon-left", {
            'bs-date-field--disabled': _ctx.disabled,
            'bs-date-field--medium': _ctx.size === 'medium',
            'bs-date-field--big': _ctx.size === 'big',
            'bs-date-field--opened': _ctx.isVisible,
            'bs-date-field--invalid': _ctx.invalid,
        }]),
    ref: "containerReference"
  }, [
    _createElementVNode("div", {
      class: "bs-date-field__trigger",
      ref: "reference",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCalendar && _ctx.toggleCalendar(...args)))
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        (Boolean(_ctx.displayValue))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.displayValue), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.placeholder), 1))
      ])
    ], 512),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "m-tooltip" }, {
      default: _withCtx(() => [
        (_ctx.isVisible)
          ? (_openBlock(), _createBlock(_component_bs_date_calendar, {
              key: 0,
              ref: "tooltip",
              value: _ctx.modelValue,
              disabled: _ctx.disabled,
              "output-format": _ctx.outputFormat,
              style: _normalizeStyle({ position: _ctx.strategy, left: `${_ctx.x}px`, top: `${_ctx.y}px` }),
              onUpdate: _ctx.onUpdate
            }, null, 8, ["value", "disabled", "output-format", "style", "onUpdate"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}